import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

// Every page is reachable from here; the highlighted link follows the URL.
// alsoActiveOn keeps a link highlighted on pages opened from it (e.g. New Email).
const navGroups = [
  {
    links: [
      { path: '/', label: 'Overview', icon: 'bi-graph-up' },
    ],
  },
  {
    label: 'Email',
    links: [
      { path: '/email-messages', label: 'Messages', icon: 'bi-envelope', alsoActiveOn: ['/new-email'] },
      { path: '/email-addresses', label: 'Addresses', icon: 'bi-person-lines-fill' },
      { path: '/email-templates', label: 'Templates', icon: 'bi-file-earmark-text' },
    ],
  },
  {
    label: 'SMS',
    links: [
      { path: '/sms-messages', label: 'Messages', icon: 'bi-chat-dots', alsoActiveOn: ['/new-sms'] },
      { path: '/phone-numbers', label: 'Phone Numbers', icon: 'bi-phone' },
      { path: '/sms-templates', label: 'Templates', icon: 'bi-file-earmark-text' },
    ],
  },
];

const itemClass = (active) =>
  `btn text-start w-100 py-2 px-3 rounded-2 border-0 border-start border-3 ${
    active ? 'border-primary text-primary fw-semibold bg-primary bg-opacity-10' : 'border-light text-secondary'
  }`;

const groupLabelStyle = {
  fontSize: '0.7rem',
  fontWeight: 600,
  letterSpacing: '0.05em',
  textTransform: 'uppercase',
  color: '#6c757d',
};

function Sidebar() {
  const { pathname } = useLocation();

  return (
    <aside style={{
      width: '230px',
      minWidth: '230px',
      height: 'calc(100vh - 75px)',
      backgroundColor: '#fff',
      overflowY: 'auto',
      overflowX: 'hidden',
      padding: '0.5rem',
      position: 'sticky',
      top: '75px',
    }}>
      <nav className="d-flex flex-column" aria-label="Main">
        {navGroups.map((group, i) => (
          <React.Fragment key={group.label ?? i}>
            {group.label && (
              <div className="px-3 mt-3 mb-1" style={groupLabelStyle}>{group.label}</div>
            )}
            {group.links.map((link) => (
              <NavLink
                key={link.path}
                to={link.path}
                end
                className={({ isActive }) => itemClass(isActive || link.alsoActiveOn?.includes(pathname))}
                style={{ textDecoration: 'none' }}
              >
                <i className={`bi ${link.icon} me-2`}></i>
                {link.label}
              </NavLink>
            ))}
          </React.Fragment>
        ))}
      </nav>
    </aside>
  );
}

export default Sidebar;
